const planOptions = {
  bravePlus: {
    title: "BRAVE+ Sub",
    annual: {
      sellingPlanId: 3225813250,
      variantId: 45903187673346,
      price: "$59.99/year",
      priceInt: 59.99
    },
    monthly: {
      sellingPlanId: 3209822466,
      variantId: 46103323050242,
      price: "$9.99/month",
      priceInt: 9.99
    },
  },
  bookSub: {
    title: "BRAVE Bundle Sub",
    annual: {
      sellingPlanId: 3010167042,
      variantId: 46054529499394,
      price: "$203.88/year",
      priceInt: 203.88
    },
    monthly: {
      sellingPlanId: 3010134274,
      variantId: 46060371017986,
      price: "$18.99/month",
      priceInt: 18.99
    },
  },
  freeTrial: {
    title: "BRAVE Plus 7-day Free Trial",
    monthly: {
      sellingPlanId: 3265626370,
      variantId: 46105182142722,
      price: "$0.00",
    },
  }
};

const modalEl = document.querySelector(".brave-plus__modal");
const openModalWindow = () => {
  modalEl.setAttribute("hidden-modal", false);
  document.querySelector("html").style.overflowY = "hidden";
}

const optionBlocks = document.querySelector(".brave-plus__options");
const planSelectEls = document.querySelectorAll(".brave-plus__plan-select");
for (let plan of planSelectEls) {
  plan.addEventListener("click", (e) => {
    let selectedPlan = plan.dataset.planSelect;
    fillModal(selectedPlan);
    openModalWindow();
  });
}

const plusSelectionEl = document.querySelectorAll(".brave-plus__pricing .primary-button");
if (plusSelectionEl) {
  for (let btn of plusSelectionEl) {
    btn.addEventListener('click', () => {
      bravePlusAtc(btn, 'bravePlus', btn.dataset.termSelect, 'accountCreation');
    })
  }
}

const closeEl = document.querySelector(".brave-plus__close-window");
if (closeEl) {
  closeEl.addEventListener("click", (e) => {
    modalEl.setAttribute("hidden-modal", true);
    document.querySelector("html").style.overflowY = "unset";
    setTimeout(() => {
      document.querySelector(".modal-content__inner").innerHTML = "";
    }, 300);
  });
}

const calcSavings = (plan) => {
  const annualPerMonth = plan.annual.priceInt / 12;
  return Math.round(
    100 * ((plan.monthly.priceInt - annualPerMonth) / plan.monthly.priceInt)
  );
};

const fillModal = (plan) => {
  const modalWindow = document.querySelector(".brave-plus__modal-window");
  const modalEl = document.querySelector(".modal-content__inner");
  const planData = planOptions[plan];
  const savings = calcSavings(planData);
  modalEl.innerHTML = `
    <h3 class="text-center bold-mingler brave-plus__modal-title">Save ${savings}% every month when you pay annually</h3>
    <p class="text-center" style="margin-top: 10px;">Get the ${
      planData.title
    } for only <b>$${Math.round(planData.annual.priceInt / 12)}/month</b> (${
    planData.annual.price
  }).</p>
    <div class="button-group">
      <a
        class="primary-button brave-plus__atc"
        onclick="bravePlusAtc(this, '${plan}', 'annual')"
        style="max-width: 325px;"
      >
        Checkout with Annual
      </a>
      <a 
        class="secondary-button brave-plus__atc"
        onclick="bravePlusAtc(this, '${plan}', 'monthly')"
        style="max-width: 325px; width: 100%;"
      >
        Continue at ${planData.monthly.price}
      </a>
    </div>
  `;
};

const bravePlusAtc = (e, planName, term, urlTarget) => {
  if (planName == 'plusTest') {
    e.innerHTML = "loading...";
  } else {
    e.innerHTML = "Adding...";
  } 
  const formData = {
    items: [
      {
        quantity: 1,
        id: planOptions[planName][term].variantId,
        selling_plan: planOptions[planName][term].sellingPlanId,
        form_type: "product",
        properties: {
          _custom_order_tag: `${planOptions[planName].title}/${term}`,
        },
      },
    ],
  };
  $.ajax({
    type: "POST",
    url: "/cart/add",
    dataType: "json",
    data: formData,
    success: async function (res) {
      if (urlTarget) {
        window.location.href = "https://bravebooks.us/pages/brave-registration";
      } else {
        e.innerHTML = "Added";
        e.removeAttribute("disabled", "");
        window.location.href = "/checkout";
      }
    },
  }).fail(function (e) {
    e.innerHTML = "Added";
  });
};
